import React from 'react'
import { Card } from 'antd-mobile'
import { YenSpan } from '../common/YenSpan'

class ProductListItem extends React.PureComponent {
  static defaultProps = {
    name: '-',
    currentPrice: '-',
    imgSrc: null
  }

  render () {
    // const {
    //   title, imgSrc, price
    // } = this.props
    const {
      name,
      // id,
      productId,
      productPic: imgSrc,
      currentPrice,
      stock
    } = this.props
    return <Card className={'!rounded-none'}
                 key={productId}
                 onClick={this.onClick}>
        <div className={'flex items-start'}>
          <img className={'product-thumb'} src={imgSrc} alt='' />
          <div className={'item-card__content'}>
            <div className='item-card__title'>
              {name}
            </div>
            <div className={'flex justify-between'}>
              <YenSpan
                className='item-card__price item-card__price--red item-card__price--large'>{currentPrice}</YenSpan>
              <div>
                {/*<Tag selected={false}>包邮</Tag>*/}
              </div>
            </div>
            <br />
            <div className={'flex justify-between'}>
              <div style={{ fontSize: 10, color: 'grey' }}>库存: {stock}</div>
              <div className={'item-card__icon'} onClick={this.onIconClick}><i className={'icon-font icon-cart'} /></div>
            </div>
          </div>
        </div>
    </Card>
  }

  onClick = () => {
    this.props.onClick(this.props.id)
  }

  onIconClick = e => {
    e.stopPropagation()
    e.preventDefault()
    this.props.onIconClick && this.props.onIconClick({ id: this.props.id, stock: this.props.stock })
  }
}

// const ProductListRow = (rowData) => {
//   return <ProductListItem {...rowData} />
// }

export { ProductListItem }
